import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { registerServiceWorker } from './utils/pushNotifications';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><App /></React.StrictMode>);

// Register the service worker so push notifications can wake the app even
// when the tab is closed. Safe to call early — no permission prompt fires
// until the user explicitly clicks "Enable reminders".
registerServiceWorker();
